import type { DeviceStatusType, DeviceTelemetrySnapshot } from '../types'

type DeviceStatusBaseline = Pick<DeviceStatusType, 'alertStatus' | 'resource'>

type ToDeviceStatusParams = {
  id: string
  telemetry?: DeviceTelemetrySnapshot
  baseline?: Partial<DeviceStatusBaseline>
}

const numericFrameValue = (telemetry: DeviceTelemetrySnapshot | undefined, type: string, fallback: number): number => {
  const parsed = Number(telemetry?.frames.find((frame) => frame.type === type)?.value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const toDeviceStatus = ({ id, telemetry, baseline }: ToDeviceStatusParams): DeviceStatusType => {
  const telemetryFreshness = telemetry?.freshness ?? 'never'
  const isLive = telemetryFreshness === 'live'
  const alertStatus = isLive
    ? telemetry?.frames.find((frame) => frame.type === 'alert')?.value ?? baseline?.alertStatus ?? 'normal'
    : baseline?.alertStatus ?? 'normal'
  const resource = isLive ? numericFrameValue(telemetry, 'resurs', baseline?.resource ?? 0) : baseline?.resource ?? 0
  const liveWorkingValue = numericFrameValue(telemetry, 'workingStatus', 0)

  return {
    id,
    alertStatus,
    resource,
    // Po 180 s bez telemetrii urządzenie jest OFF niezależnie od ostatniej wartości ramki.
    isWorking: isLive && liveWorkingValue !== 0 ? 1 : 0,
    telemetryFreshness,
  }
}
